const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/user-management/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { requireEditOrganizationPermission } from '@/lib/queries/access/usePermissions';
export const Route = createFileRoute('/(app)/org/$org/settings/user-management')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ({
    context
  }) => {
    await requireEditOrganizationPermission(context);
  }
});